/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_SubtitleInputs */

const en_home_subtitle = /** @type {(inputs: Home_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You belong to more than one team. Pick the one you want to open.`)
};

const id_home_subtitle = /** @type {(inputs: Home_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu anggota di beberapa tim. Pilih yang mau kamu buka.`)
};

/**
* | output |
* | --- |
* | "You belong to more than one team. Pick the one you want to open." |
*
* @param {Home_SubtitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const home_subtitle = /** @type {((inputs?: Home_SubtitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_SubtitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_subtitle(inputs)
	return en_home_subtitle(inputs)
});